import React from 'react';
import { motion } from 'framer-motion';

const New_Logo = () => {
    return (
        <div className="flex items-center gap-2.5 select-none group cursor-pointer">
            {/* The Pulse Core - A high-tech geometric orb */}
            <div className="relative w-10 h-10 flex items-center justify-center">
                <div className="absolute inset-0 rounded-lg border-2 border-pulse/30 opacity-70" />
                <div className="absolute inset-[20%] rounded-full bg-gradient-to-tr from-pulse via-electric to-accent shadow-[0_0_15px_hsl(var(--pulse))]" />
                <div className="relative w-2 h-2 rounded-full bg-white shadow-[0_0_10px_white]" />
            </div>

            {/* PulseChat Text with Chromatic Aberration / Glitch Effect */}
            <div className="flex flex-col justify-center -space-y-1">
                <h1 className="font-sans text-2xl font-black tracking-tighter flex items-center uppercase italic text-white">
                    Pulse Chat
                </h1>
                <div className="h-[2px] w-full bg-gradient-to-r from-pulse via-electric to-transparent rounded-full opacity-50 overflow-hidden" />
            </div>
        </div>
    );
};

export default New_Logo;
